import Modal from '@/common/components/Modal'
import { ModalMessageSimple } from '@/common/components/ModalMessageSimple'
import { FormTransformers } from '@/common/utils/formTransformers'
import { useDeleteCompanyBranchAdditionalDocument } from '@/features/privateCompanies/hooks/branches/useDeleteCompanyBranchAdditionalDocument'
import { useQueryClient } from '@tanstack/react-query'
import { useState } from 'react'
import { useParams } from 'react-router-dom'

interface ModalDeleteAdditionalDocumentProps {
  attachmentId?: string
  setAttachmentId: (attachmentId?: string) => void
}

export const ModalDeleteAdditionalDocument = ({
  attachmentId,
  setAttachmentId,
}: ModalDeleteAdditionalDocumentProps) => {
  const { id: branchId } = useParams()
  const queryClient = useQueryClient()

  const [messages, setMessages] = useState<string[] | boolean>(false)

  const onSuccess = () => {
    setAttachmentId()
    queryClient.invalidateQueries({ queryKey: ['companyBranch', branchId] })
  }

  const { mutate: deleteCompanyBranchAdditionalDocument, isPending: deleteCompanyBranchAdditionalDocumentIsPending } =
    useDeleteCompanyBranchAdditionalDocument({
      branchId,
      onSuccess,
      onError: FormTransformers.errorsTransformer({ setMessages }),
    })

  return (
    <>
      <Modal
        isOpen={!!attachmentId}
        setIsOpen={() => setAttachmentId()}
        title="Confirmar Exclusão"
        subtitle="Tem certeza que deseja excluir este documento? Esta ação não pode ser desfeita."
        titleClass="text-2xl"
        subtitleClassName="mt-1 text-sm"
        showClose={false}
        useCancellableFooter
        disabled={deleteCompanyBranchAdditionalDocumentIsPending}
        onConfirm={() => deleteCompanyBranchAdditionalDocument(attachmentId!)}
      />

      <ModalMessageSimple
        messages={messages}
        setMessages={setMessages}
        onClose={() => {
          setAttachmentId()
        }}
        isError
      />
    </>
  )
}
